
import BusinessLogo from "@/components/business/BusinessLogo"
import VideoCookiePlaceholder from "@/components/base/video/VideoCookiePlaceholder"

import consentCookieMixin from "@/mixins/consentCookieMixin"
import { routeToBusiness } from "@/helpers/routing"

import vueVimeoPlayer from "vue-vimeo-player"
import vueSmoothScroll from "vue2-smooth-scroll"
import Vue from "vue"
Vue.use(vueSmoothScroll)
Vue.use(vueVimeoPlayer)

export default {
    name: "PostDetailCard",
    components: {
        VideoCookiePlaceholder,
        BusinessLogo,
    },
    mixins: [consentCookieMixin],
    props: {
        displayedPost: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            playerReady: false,
            showQuestion: true,
            showGif: false,
            showHeart: false,
            openShareMenu: false,
            gifNumber: 0,
            alreadyLiked: false,
            gifLinks: [
                "https://media0.giphy.com/media/V9ylxG8HD8cZW/giphy.gif",
                "https://media0.giphy.com/media/RlHVpsV3w8zO9lyE2E/giphy.gif",
                "https://media1.giphy.com/media/Wpr41GG0tJW33ZI4dM/giphy.gif",
                "https://media0.giphy.com/media/8cKr9K7WTFJj2lTXZb/giphy.gif",
                "https://media3.giphy.com/media/Kzbzs6Q2ZBKbpfEzGp/giphy.gif?cid=ecf05e4766bb1aac5959a2f827d8459ab63234bcc66a6fd7&rid=giphy.gif",
                "https://media3.giphy.com/media/Jf4FBs6JZhvKU/giphy.gif",
                "https://media1.giphy.com/media/AEzIKaaOTkO9eyGUDK/giphy.gif",
                "https://media1.tenor.com/images/937afa3ef2877cd52256d6e2aa1c9a4e/tenor.gif",
                "https://media1.tenor.com/images/65b3da99d3626f98e84f014f01d62b31/tenor.gif",
                "https://media1.tenor.com/images/d076ed43f9ce9e26d71dcb74a7bd898f/tenor.gif",
                "https://media1.tenor.com/images/57e85e72bcb1908f905494ca21a4517a/tenor.gif",
                "https://media1.tenor.com/images/38f8285db4dba1e8c524b2e6b623e831/tenor.gif",
                "https://media1.tenor.com/images/b936d6d6247faccc87e36d805ef60282/tenor.gif",
            ],
        }
    },
    computed: {
        image() {
            return this.$getImage({
                image: this.displayedPost.image,
                preferedSize: 1,
            })
        },
        routeToBusiness() {
            return routeToBusiness(this.displayedPost.author)
        },
    },
    methods: {
        close() {
            if (!this.loadingBack) {
                this.loadingBack = true
                if (this.$route.params.from_name !== null) {
                    this.$router.back()
                } else {
                    if (this.displayedPost.author_type === "business") {
                        this.$router.replace(this.routeToBusiness)
                    }
                }
            }
        },
        play() {
            this.$refs.player.play()
        },
        pause() {
            this.$refs.player.pause()
        },
        like() {
            this.$axios
                .post("/api/post/like", {
                    slug: this.displayedPost.slug,
                })
                .then(() => {
                    this.$auth.$storage.setCookie(
                        "apply-" + this.displayedPost.slug,
                        true
                    )
                    let el = this.$el.getElementsByClassName("like-box")[0]
                    this.gifNumber = Math.floor(
                        Math.random() * this.gifLinks.length
                    )
                    this.$smoothScroll({
                        scrollTo: el,
                        offset: -100,
                        updateHistory: false,
                    })
                    if (!this.alreadyLiked) {
                        this.showQuestion = false
                        setTimeout(() => {
                            this.showGif = true
                        }, 1000)
                        setTimeout(() => {
                            this.showGif = false
                        }, 3000)
                        setTimeout(() => {
                            this.alreadyLiked = true
                        }, 4000)
                        setTimeout(() => {
                            this.showHeart = true
                        }, 6000)
                    }
                })
        },
    },
}
